<template>
  <div class="col-12">
    <div class=" row text-center m-5">
      <h3 class="ui inverted purple text"> <strong> Failed</strong></h3>
    </div>
    <div class="row d-flex justify-content-center align-items-center mt-5">
      <div class="col-11 col-lg-9">
        <div class="ui violet floating message m-4">
          <div class="header mb-2">
            TN CyberTech Bank
          </div>
          <p>Apologies, unfortunately we are not able to retrieve your correct details, please consider choosing the current account option.</p>
        </div>
          <button class="ui button  grey fluid mt-4 mb-4" @click="login()">Logout</button>
      </div>
    </div>
  </div>
</template>
<script>
import baseMethods from "@/utils/baseMethods";

export default {
  name: 'ISaveFailed',
  data() {
  return {customer : {
  mobileNumber : ""
  },
    errors: {},
      operations: 0,
  };
  },
  mounted() {},
  methods: {
      close() {
      // todo: send close request to backend
    },
      login() {
          this.$router.push("/account-opening/login");
      },
    submitForm() {
        localStorage.setItem("phone-number", this.customer.mobileNumber);
        this.$router.push("/account-opening/customer-details");
    },
    ...baseMethods,
  }
};
</script>